export default "__VITE_ASSET__04607710__"